<template>
  <span
    v-bind="$attrs"
    :class="$style.base"
    :style="`color: var(--color-${color})`"
  />
</template>

<script setup lang="ts">
enum IconContent {
  iconCalRound = '"\\e900"',
  iconCheck = '"\\e901"',
  iconAdd = '"\\e902"',
  iconCheckRound = '"\\e903"',
  iconChevronRound = '"\\e904"',
  iconCal = '"\\e905"',
  iconChat = '"\\e906"',
  iconInfo = '"\\e907"',
  iconChevron = '"\\e908"',
  iconTime = '"\\e909"',
  iconTodo = '"\\e90a"',
  iconUser = '"\\e90b"',
  iconStar = '"\\e90c"',
  iconConfirm = '"\\e90f"',
  iconLocation = '"\\e910"',
  iconWench = '"\\e911"',
  iconMail = '"\\e912"',
  iconCall = '"\\e913"',
  iconTechnician = 'url(base/assets/icons/icon_technician.svg)',
  iconTick = 'url(base/assets/icons/tick.svg)'
}

enum IconSize {
  sm = 10,
  md = 20,
  lg = 30,
}

interface IconProps {
  icon: keyof typeof IconContent,
  size?: keyof typeof IconSize,
  color?: 'pacificblue' | 'turquoise'
}

const { icon, size = 'md', color = 'pacificblue' } = defineProps<IconProps>()

const iconContent = computed(() => IconContent[icon])
const iconSize = computed(() => IconSize[size])
</script>

<style module>
.base {
  font-family: icomoon;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  &:before {
    display: inline-block;
    content: v-bind(iconContent);
    font-size: v-bind(iconSize + 'px');
    width:  v-bind(iconSize + 'px');
    height:  v-bind(iconSize + 'px');
  }
}
</style>
